const StoryDead = () => {
  return null;
}
 
export default StoryDead;